function remToPx(rem) {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

async function getImageAspectRatio(img) {
  if (!(img instanceof HTMLImageElement)) {
    throw new Error("Argument must be an HTMLImageElement");
  }
  const computeRatio = () => img.naturalWidth / img.naturalHeight;

  if (img.complete && img.naturalWidth) {
    return computeRatio();
  }

  return new Promise((resolve, reject) => {
    img.addEventListener("load", () => resolve(computeRatio()), { once: true });
    img.addEventListener(
      "error",
      () => reject(new Error("Image failed to load")),
      { once: true }
    );
  });
}

const setupHero = async (heroEl) => {
  if (!heroEl) {
    return;
  }

  const heroMarkers = [...heroEl.querySelectorAll(".js-hero-marker")];
  const heroBg = heroEl.querySelector(".js-hero-background");

  if (!heroBg) {
    return;
  }

  const aspectRatio = await getImageAspectRatio(heroBg);

  const debugTl = heroEl.querySelector(".js-hero-debug-tl");
  const debugTr = heroEl.querySelector(".js-hero-debug-tr");
  const debugBr = heroEl.querySelector(".js-hero-debug-br");
  const debugBl = heroEl.querySelector(".js-hero-debug-bl");
  const debugCenter = heroEl.querySelector(".js-hero-debug-center");

  const targetLeft = +heroEl.dataset.targetLeft;
  const targetTop = +heroEl.dataset.targetTop;
  const targetHeight = +heroEl.dataset.targetHeight;
  const targetWidth = +heroEl.dataset.targetWidth;

  const targetAspect = (targetWidth * aspectRatio) / targetHeight;

  const resize = () => {
    let paddingTop =
      getComputedStyle(heroEl).getPropertyValue("--hero-padding-top") || "0rem";
    let paddingBottom =
      getComputedStyle(heroEl).getPropertyValue("--hero-padding-bottom") ||
      "0rem";

    paddingTop = remToPx(paddingTop);
    paddingBottom = remToPx(paddingBottom);

    const availableWidth = heroEl.clientWidth;
    const availableHeight = heroEl.clientHeight - paddingTop - paddingBottom;

    const availableAspect = availableWidth / availableHeight;

    let appliedTargetWidth = 1;
    let appliedTargetHeight = 1;

    let appliedTotalHeight = 1;
    let appliedTotalWidth = 1;

    if (targetAspect > availableAspect) {
      appliedTargetWidth = availableWidth;
      appliedTargetHeight = availableWidth / targetAspect;

      appliedTotalWidth = appliedTargetWidth / targetWidth;
      appliedTotalHeight = appliedTotalWidth / aspectRatio;
    } else {
      appliedTargetHeight = availableHeight;
      appliedTargetWidth = availableHeight * targetAspect;

      appliedTotalHeight = appliedTargetHeight / targetHeight;
      appliedTotalWidth = appliedTotalHeight * aspectRatio;
    }

    let centerX = heroEl.clientWidth / 2;
    let centerY =
      (heroEl.clientHeight - paddingTop - paddingBottom) / 2 + paddingTop;

    let imageCenterY = (targetTop + targetHeight / 2) * appliedTotalHeight;
    let imageCenterX = (targetLeft + targetWidth / 2) * appliedTotalWidth;

    let imageTop = -imageCenterY + centerY;
    let imageLeft = -imageCenterX + centerX;

    heroBg.style.setProperty("--bg-top", `${imageTop}px`);
    heroBg.style.setProperty("--bg-left", `${imageLeft}px`);
    heroBg.style.setProperty("--bg-height", `${appliedTotalHeight}px`);
    heroBg.style.setProperty("--bg-width", `${appliedTotalWidth}px`);

    let appliedTargetLeft = imageCenterX - appliedTargetWidth / 2 + imageLeft;
    let appliedTargetTop = imageCenterY - appliedTargetHeight / 2 + imageTop;

    debugTl.style.left = `${appliedTargetLeft}px`;
    debugTl.style.top = `${appliedTargetTop}px`;

    debugTr.style.left = `${appliedTargetLeft + appliedTargetWidth}px`;
    debugTr.style.top = `${appliedTargetTop}px`;

    debugBr.style.left = `${appliedTargetLeft + appliedTargetWidth}px`;
    debugBr.style.top = `${appliedTargetTop + appliedTargetHeight}px`;

    debugBl.style.left = `${appliedTargetLeft}px`;
    debugBl.style.top = `${appliedTargetTop + appliedTargetHeight}px`;

    for (const marker of heroMarkers) {
      const left = +marker.dataset.markerLeft;
      const top = +marker.dataset.markerTop;

      const dx = left * appliedTargetWidth;
      const dy = top * appliedTargetHeight;

      const appliedLeft = appliedTargetLeft + dx;
      const appliedTop = appliedTargetTop + dy;

      marker.style.setProperty("--marker-left", `${appliedLeft}px`);
      marker.style.setProperty("--marker-top", `${appliedTop}px`);

      marker.style.opacity = 1;
    }

    heroBg.style.opacity = 1;
  };

  new ResizeObserver(resize).observe(heroEl);

  //window.addEventListener("resize", resize);

  resize();
};

document.addEventListener("page:load", () => {
  const markerBtns = document.querySelectorAll(".js-hero-marker-btn");
  const markers = document.querySelectorAll(".js-hero-marker");

  for (const markerBtn of markerBtns) {
    markerBtn.addEventListener("click", function () {
      const marker = this.closest(".js-hero-marker");
      const popover = marker.querySelector(".js-hero-marker-popover");

      const isOpen = marker.classList.contains("js-hero-marker--open");

      for (const item of markers) {
        item.classList.remove("js-hero-marker--open");
        const popover_ = item.querySelector(".js-hero-marker-popover");

        if (popover_?.classList?.contains("js-hero-marker-popover--shown")) {
          popover_.classList.remove("js-hero-marker-popover--shown");
          popover_.hidePopover();
        }
      }

      if (!isOpen) {
        marker.classList.add("js-hero-marker--open");

        if (popover?.showPopover) {
          popover.classList.add("js-hero-marker-popover--shown");
          popover.showPopover();
        }
      }
    });
  }

  window.addEventListener("click", (e) => {
    if (
      e.target.closest(".js-hero-marker--open") ||
      e.target.classList.contains("js-hero-marker--open")
    ) {
      return;
    }

    for (const item of markers) {
      item.classList.remove("js-hero-marker--open");
    }
  });

  const heroEls = document.querySelectorAll(".js-hero-markers");

  for (const heroEl of heroEls) {
    setupHero(heroEl);
  }
});
